import React, { useRef } from 'react';

import useWWSUrl from '../../helpers/useWWSUrl';
import { Track } from '../../TrackingContext';
import styles from './url.scss';
import UrlCopy from './UrlCopy';
import { Snackbar } from '@xo-union/tk-component-alerts';
import { SnackbarInterface, DISMISS_TIMEOUT } from '../../helpers/snackbar';

interface Props {
  track: Track;
}

const Url: React.FC<Props> = ({ track }) => {
  const url = useWWSUrl();
  const snackbar = useRef<SnackbarInterface>();

  const wwsUrlCopiedEvent = () => {
    track('Website Link Copied', {
      source: 'dashboard',
    });
    if (snackbar?.current) {
      snackbar.current.showAndDismiss({
        data: 'Website link copied',
        dismissTimeout: DISMISS_TIMEOUT,
      });
    }
  };

  return (
    <>
      <Snackbar ref={snackbar} />
      <span data-testid="share-url" className={styles.url}>
        {url}
      </span>
      <UrlCopy url={url} onCopy={wwsUrlCopiedEvent} />
    </>
  );
};

export default Url;
